import React, {useState} from 'react';
import {Sidebar} from './components/Sidebar/Sidebar';
import {MobileSidebar} from './components/Sidebar/MobileSidebar';
import {UserMenu} from './components/Header/UserMenu';
import {UserFeedback} from './components/Feedback/UserFeedback';

import {Outlet} from 'react-router-dom';
import {Breadcrumbs} from '../navigation/Breadcrumbs.tsx';
import {useBreadcrumbs} from '../../hooks/useBreadcrumbs';
import {StatusAnnouncement} from '../StatusAnnouncement';
import {GdprToggle} from './components/Header/GdprToggle';

export const Layout: React.FC = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { breadcrumbs, isLoading } = useBreadcrumbs();

  return (
    <div>
      <MobileSidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      <Sidebar />

      {/* Main content */}
      <div className="lg:pl-20">
        <StatusAnnouncement />
        <div data-testid="app-header" className="sticky top-0 z-40 flex h-16 shrink-0 items-center gap-x-4 border-b border-gray-200 bg-white px-4 shadow-sm sm:gap-x-6 sm:px-6 lg:px-8">
          <button
            type="button"
            className="-m-2.5 p-2.5 text-gray-700 lg:hidden"
            onClick={() => setSidebarOpen(true)}
          >
            <span className="sr-only">Open sidebar</span>
            <Bars3Icon className="h-6 w-6" aria-hidden="true" />
          </button>

          <div className="h-6 w-px bg-gray-900/10 lg:hidden" aria-hidden="true" />

          <div className="flex flex-1 gap-x-4 self-stretch lg:gap-x-6">
            <Breadcrumbs items={breadcrumbs} isLoading={isLoading} />

            <div className="flex flex-1" />
            <div className="flex items-center gap-x-4 lg:gap-x-6">
              <a
                href="https://status.yojo.health"
                target="_blank"
                rel="noopener noreferrer"
                className="hidden lg:flex items-center"
              >
                <iframe
                  src="https://status.yojo.health/badge?theme=light"
                  width="250"
                  height="30"
                  frameBorder="0"
                  scrolling="no"
                  style={{border: 'none', pointerEvents: 'none'}}
                  title="System status"
                />
              </a>

              <GdprToggle />

              <UserFeedback />

              <div className="hidden lg:block lg:h-6 lg:w-px lg:bg-gray-900/10" />

              <UserMenu />
            </div>
          </div>
        </div>

        <main className={'transition-all duration-300'}>
          <div className="px-4 py-10 sm:px-6 lg:px-8 lg:py-6">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
};

function Bars3Icon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" {...props}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
    </svg>
  );
}
